/**
 * @description 页面逻辑基类
 * @author zhijie.huang
 * @date 2018/9/11
 */
import Logic from './logic'
import Auth from './authorize'
import Debug from './api-test'

class LogicBase {
  constructor () {
     this.NewLogicAssociation =  new Logic({Auth, Debug});
  }
  create( requestInterface ,data , noLoading ){
  	return this.NewLogicAssociation.ajax({
  		...this.NewLogicAssociation.REQUEST_OPT[requestInterface],
  		data
  	},false,noLoading)
  }
}

export default LogicBase



// WEBPACK FOOTER //
// ./src/logic/logic-base.js